import { XyoWorldEntity } from '../../Hooks'

export interface SortableEntity {
  entity: XyoWorldEntity
}

export interface SortableByLandArea extends SortableEntity {
  landArea?: number
}

export const getSortByLandAreaEntities = (entities: XyoWorldEntity[]): SortableByLandArea[] => {
  return (
    entities?.map((entity): SortableByLandArea => {
      return {
        entity,
        landArea: entity.getGeotokenList()?.landArea,
      }
    }) ?? []
  )
}

export const sortEntitiesLandAreaHighToLow = (entities: SortableByLandArea[]) => {
  return entities.sort((n1, n2) => {
    if ((n1.landArea ?? 0) > (n2.landArea ?? 0)) {
      return -1
    }
    if ((n1.landArea ?? 0) < (n2.landArea ?? 0)) {
      return 1
    }
    return 0
  })
}

export const sortEntitiesLandAreaLowToHigh = (entities: SortableByLandArea[]) => {
  return entities.sort((n1, n2) => {
    if ((n1.landArea ?? 0) > (n2.landArea ?? 0)) {
      return 1
    }
    if ((n1.landArea ?? 0) < (n2.landArea ?? 0)) {
      return -1
    }
    return 0
  })
}
